import { Helmet } from "react-helmet-async";

const SITE = "https://mykind.app";
const DEFAULT_IMG = `${SITE}/mykind-og.jpg`;

/**
 * Per-page SEO tags. Googlebot renders JS and reads these; also sets the browser tab title.
 * Static crawlers (FB/WhatsApp/LinkedIn) rely on the tags baked into public/index.html.
 */
export default function Seo({ title, description, keywords, path = "", image = DEFAULT_IMG, type = "website", jsonLd }) {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} · My Kind` : "My Kind — Social, Health, Education, Travel, Food & Events, Personalised";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="My Kind" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
